import { placeSegments, Segment, barWidth } from "./format";
import styles from "./dash.module.css";

interface Props {
  segments: Segment[];
  /** longest total in the list; bars are scaled against it so rows compare */
  max?: number;
  label: string;
}

/** Horizontal stacked bar. Colour is backed by a text alternative (aria-label + title). */
export const StackedBar = ({ segments, max, label }: Props) => {
  const placed = placeSegments(segments);
  const total = segments.reduce((n, s) => n + s.value, 0);
  const width = max === undefined ? 100 : barWidth(total, max);
  const summary = placed.length ? placed.map((s) => `${s.label} ${s.value}`).join(", ") : "none";
  return (
    <div className={styles.barTrack}>
      <div
        className={styles.barFill}
        style={{ width: `${width}%` }}
        role="img"
        aria-label={`${label}: ${summary}`}
        title={summary}
      >
        {placed.map((s) => (
          <span key={s.key} className={styles.barSeg} style={{ width: `${s.pct}%`, background: s.color }} />
        ))}
      </div>
    </div>
  );
};

export const Legend = ({ items }: { items: { key: string; label: string; color: string }[] }) => (
  <ul className={styles.legend} aria-label="Legend">
    {items.map((i) => (
      <li key={i.key} className={styles.legendItem}>
        <span className={styles.swatch} style={{ background: i.color }} aria-hidden="true" />
        {i.label}
      </li>
    ))}
  </ul>
);
